<script setup lang="ts">
defineProps<{
  label?: string
  name: string
}>();

const modelValue = defineModel<boolean>();
</script>

<template>
  <label class="flex gap-xs items-center group/checkbox cursor-pointer text-neutral-10 hover:text-secondary text-sm">
    <input
      v-model="modelValue"
      type="checkbox"
      class="sr-only peer"
      :name
    >
    <Icon
      class="size-10 fill-secondary hidden group-has-[:checked]/checkbox:flex
        group-has-[:focus-within]/checkbox:outline group-has-[:focus-within]/checkbox:outline-2 group-has-[:focus-within]/checkbox:outline-primary-40"
      name="iad-icon:checked"
    />
    <Icon
      class="size-10 fill-black flex group-has-[:checked]/checkbox:hidden
        group-has-[:focus-within]/checkbox:outline group-has-[:focus-within]/checkbox:outline-2 group-has-[:focus-within]/checkbox:outline-primary-40"
      name="iad-icon:unchecked"
    />
    <span
      class="flex-1"
      v-text="label"
    />
  </label>
</template>

<style lang="css" scoped>
label:focus-within:not(:has(:focus-visible)) svg {
  @apply outline-none;
}
</style>
